// Dismissible "Getting started" checklist, fixed bottom-right across /profile.
// Steps auto-complete from OnboardingProvider's status (real exchange / locked
// assets / bot), each deep-links to the matching one-click flow. Hides when all
// three are done or the user dismisses it.
import React, { useState } from 'react';
import { Box, Typography, IconButton, Collapse } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useHistory } from 'react-router-dom';
import { C, SANS, MONO } from '../../theme/matteTokens';
import { useOnboarding } from './OnboardingProvider';

export default function GettingStarted() {
  const { status, checklistDismissed, dismissChecklist } = useOnboarding();
  const history = useHistory();
  const [open, setOpen] = useState(true);

  if (!status || checklistDismissed || status.loading) return null;

  const items = [
    { key: 'ex', done: status.hasExchange, label: 'Create an exchange', cta: 'Create demo', go: () => history.push('/profile/portfolio?onboard=demo') },
    { key: 'lock', done: status.hasLockedAssets, label: 'Add & lock assets', cta: 'Open', go: () => history.push('/profile/portfolio') },
    { key: 'bot', done: status.hasBot, label: 'Create your first bot', cta: 'Quick Bot', go: () => history.push('/profile/traderform?quickbot=1') },
  ];
  const doneCount = items.filter((i) => i.done).length;
  if (doneCount === items.length) return null; // fully onboarded → hide

  return (
    <Box sx={{ position: 'fixed', right: 20, bottom: 'calc(20px + var(--ui-tabbar-offset, 0px))', width: 300, maxWidth: 'calc(100vw - 32px)', bgcolor: C.card, border: `1px solid ${C.hairline}`, borderRadius: '14px', boxShadow: '0 12px 40px rgba(0,0,0,.5)', fontFamily: SANS, zIndex: 1500, overflow: 'hidden' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: '12px 8px 12px 14px', cursor: 'pointer' }} onClick={() => setOpen((o) => !o)}>
        <Box>
          <Typography sx={{ fontSize: '13.5px', fontWeight: 700, color: C.bright }}>Getting started</Typography>
          <Typography sx={{ fontFamily: MONO, fontSize: '10.5px', color: C.muted }}>{doneCount}/{items.length} complete</Typography>
        </Box>
        <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }}>
          <IconButton size="small" aria-label="Dismiss getting-started checklist" onClick={(e) => { e.stopPropagation(); dismissChecklist && dismissChecklist(); }} sx={{ color: C.muted }}><CloseIcon sx={{ fontSize: 16 }} /></IconButton>
          <ExpandMoreIcon sx={{ color: C.muted, transform: open ? 'rotate(180deg)' : 'none', transition: '.2s' }} />
        </Box>
      </Box>
      <Collapse in={open}>
        <Box sx={{ p: '0 12px 12px' }}>
          {items.map((i) => (
            <Box key={i.key} sx={{ display: 'flex', alignItems: 'center', gap: 1.25, p: '9px 6px', borderTop: `1px solid ${C.hairline}` }}>
              {i.done ? <CheckCircleIcon sx={{ fontSize: 18, color: C.positive }} /> : <RadioButtonUncheckedIcon sx={{ fontSize: 18, color: C.muted }} />}
              <Typography sx={{ fontSize: '13px', color: i.done ? C.muted : C.bright, textDecoration: i.done ? 'line-through' : 'none', flex: 1 }}>{i.label}</Typography>
              {!i.done && (
                <Box component="button" onClick={i.go} sx={{ background: 'rgba(77,143,199,.12)', border: '1px solid rgba(77,143,199,.38)', color: C.accentText, fontFamily: SANS, fontSize: '11.5px', fontWeight: 600, borderRadius: '7px', px: '10px', py: '5px', cursor: 'pointer', whiteSpace: 'nowrap' }}>{i.cta}</Box>
              )}
            </Box>
          ))}
        </Box>
      </Collapse>
    </Box>
  );
}
